import React from 'react';

import { FormattedMessage } from 'react-intl';

import GlobeIcon from '@atlaskit/icon/core/globe';

import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo, RovoLogoFromLogo } from '../../icons';
import type { ThirdPartyConfigsWithAPIResponse } from '../../schemas/3p-config';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { messages } from './messages';
import { WebDomainSearchResultIcon } from './search-result-icon';

export const atlassianWebCrawlerConfig: ThirdPartyConfig = {
	displayName: <FormattedMessage {...messages['atlassian-web-crawler']} />,
	id: 'atlassian-web-crawler',
	resourceType: 'webcrawler-connector',
	icon: RovoLogoFromLogo(GlobeIcon, 'Atlassian Web Crawler'),
	searchResultIcon: get3PLogo(WebDomainSearchResultIcon, 'Atlassian Web Crawler', 'large'),
	integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WebPage,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: false,
	isEnabled: () => true,
	fanOutConnectorSources: true,
	displayWorkspaceNameAsProductName: true,
	// For web crawler, we want to filter by the domain of each datasource
	// This returns top-level filters (additionalTexts) - no product filters needed
	getFiltersForSelectedDatasources: (datasource: ThirdPartyConfigsWithAPIResponse, existingFilters) => {
		return {
			...existingFilters,
			additionalTexts: [...(existingFilters?.additionalTexts || []), ...(datasource?.workspaceUrl ? [datasource.workspaceUrl] : [])],
		};
	},
};
